import React from 'react';

import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import GDPRDescription from './gdpr-description';
import GDPRDialogButtons from './gdpr-dialog-buttons';

import styles from './gdpr-dialog.module.scss';

interface Props {
  open: boolean;
}

export const GDPRDialogContent: React.FC<Props> = (props: Props) => {
  const { open } = props;

  const { focusKey, ref, focusSelf } = useFocusable();

  React.useEffect(() => {
    focusSelf();
  }, [open, focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles['gdpr-wrapper']}>
        <GDPRDescription openedFromSettings={false} />
        <GDPRDialogButtons />
      </div>
    </FocusContext.Provider>
  );
};

export default React.memo(GDPRDialogContent);
